import { render } from "./ChartPercentageComponent.vue?vue&type=template&id=4069f25c&scoped=true"
import script from "./ChartPercentageComponent.vue?vue&type=script&lang=js"
export * from "./ChartPercentageComponent.vue?vue&type=script&lang=js"

import "./ChartPercentageComponent.vue?vue&type=style&index=0&id=4069f25c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4069f25c"

export default script